import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  Co2QuizQuestion,
  CalculationType,
  CalculationLabel,
  QuestionType,
} from '@/models/co2-quiz.model';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2CalculationWarnings',
  props: {
  question: {
    type: Object as PropType<Co2QuizQuestion>,
    required: true,
  },
  questions: {
    type: Object as PropType<Co2QuizQuestion[]>,
    required: true,
  },
},
  setup(__props) {



const warnings = [
  {
    id: 1,
    type: QuestionType.Answers,
    answers: true,
  },
  {
    id: 2,
    type: QuestionType.UserInput,
    answers: false,
  },
  {
    id: 3,
    type: QuestionType.PartsQuestion,
    parts: true,
    answers: false,
  },
  {
    id: 4,
    calculation: CalculationType.Car,
    labels: [
      CalculationLabel.CarFuel,
      CalculationLabel.CarKM,
      CalculationLabel.CarSharing,
      CalculationLabel.CarPassengers,
    ],
  },
  {
    id: 5,
    calculation: CalculationType.Motor,
    labels: [CalculationLabel.MotorFuel, CalculationLabel.MotorPassengers],
  },
  {
    id: 6,
    calculation: CalculationType.HouseSize,
    labels: [
      CalculationLabel.HouseType,
      CalculationLabel.HouseAge,
      CalculationLabel.HouseOccupants,
    ],
  },
  {
    id: 7,
    calculation: CalculationType.Electricity,
    labels: [
      CalculationLabel.HouseType,
      CalculationLabel.HouseAge,
      CalculationLabel.HouseOccupants,
    ],
    types: [CalculationType.HouseSize],
  },
  {
    id: 8,
    calculation: CalculationType.Diet,
    labels: [
      CalculationLabel.FruitAndVeg,
      CalculationLabel.Organic,
      CalculationLabel.FoodWaste,
    ],
  },
  {
    id: 9,
    calculation: CalculationType.Flying,
    chainQuestion: true,
  },
  {
    id: 10,
    calculation: CalculationType.ElectricityUsage,
    labels: [CalculationLabel.HouseOccupants],
  },
  {
    id: 11,
    calculation: CalculationType.GasUsage,
    labels: [CalculationLabel.HouseOccupants],
  },
  {
    id: 12,
    calculation: CalculationType.Mobility,
    followUp: true,
  },
];

const warningLabels = {
  answers: 'Ensure this question has answers',
  noAnswers: 'This question should not have answers',
  parts: 'This question should have part questions',
  noParts: 'This question should have part questions',
  followUp: 'At least one answer with a follow up should be available',
  chain: 'This question should have a chain question',
  labels: 'A question with the label "{{label}}" should exist',
  types: 'A question with the calculation type "{{type}}" should exist',
};

function applyLabel(v: string, value: string): string {
  return v.replace(/(\{\{.+\}\})/g, value);
}

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { style: {"padding-top":"0","padding-bottom":"0"} }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(warnings, (warning) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: warning.id
        }, [
          (
          warning.type &&
          __props.question.questionType === warning.type &&
          warning.answers &&
          !__props.question.answers.length
        )
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "warning",
                class: "mb-2",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(warningLabels.answers), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
          warning.answers === false &&
          __props.question.questionType === warning.type &&
          __props.question.answers.length
        )
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 1,
                type: "warning",
                class: "mb-2",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(warningLabels.noAnswers), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
          warning.parts &&
          __props.question.questionType === warning.type &&
          !(
            __props.questions.filter((q) => q.partQuestion?.id === __props.question.id)
              .length || __props.question.partQuestions?.length
          )
        )
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 2,
                type: "warning",
                class: "mb-2",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(warningLabels.parts), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
          warning.followUp &&
          __props.question.calculationType === warning.calculation &&
          !__props.question.answers.find((a) => a.followUpQuestion)
        )
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 3,
                type: "warning",
                class: "mb-2",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(warningLabels.followUp), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
          warning.chainQuestion &&
          __props.question.calculationType === warning.calculation &&
          !__props.question.chainQuestion
        )
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 4,
                type: "warning",
                class: "mb-2",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(warningLabels.chain), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warning.labels, (label) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: label }, [
              (
            warning.labels &&
            __props.question.calculationType === warning.calculation &&
            !__props.questions.find((q) => q.calculationLabels.includes(label))
          )
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "warning",
                    class: "mb-2",
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(applyLabel(warningLabels.labels, label)), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warning.types, (type) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: type }, [
              (
            warning.types &&
            __props.question.calculationType === warning.calculation &&
            !__props.questions.find((q) => q.calculationType === type)
          )
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "warning",
                    class: "mb-2",
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(applyLabel(warningLabels.types, type)), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
      }), 64))
    ]),
    _: 1
  }))
}
}

})